import React, { Suspense, lazy } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import urljoin from "url-join";
import axios from "axios";
import ReactRouterPropTypes from "react-router-prop-types";

import { Switch } from "react-router";
import { action as toggleMenuDispatcher } from "redux-burger-menu";
import { Link, Route } from "react-router-dom";
import { withRouter } from "react-router";

import { ajaxError, twitterShare, urlPrefetch } from "./helpers/";
import Icon from "./modules/Icon.jsx";
import MenuLink from "./components/MenuLink.jsx";

import "./AppContainer.styl";
const LoadingMessage = () => {
	let svgs = [];
	for (let index = 0; index < 32; index++) {
		svgs.push(
			<svg
				version="1.1"
				viewBox="0 0 170 142"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g fill="none" fill-rule="evenodd">
					<rect id="Rectangle" width="170" height="142" fill="#fff" />
					<rect
						id="a"
						transform="translate(85 130.5) scale(1 -1) translate(-85 -130.5)"
						x="10"
						y="123"
						width="150"
						height="15"
						fill="#D8D8D8"
					/>
					<rect
						transform="translate(85 60) scale(1 -1) translate(-85 -60)"
						width="170"
						height="120"
						fill="#D8D8D8"
					/>
				</g>
			</svg>
		);
	}
	return <div className="games-temp">{svgs}</div>;
};

async function iniciarDfp(store) {
	const {
		init
	} = await import(/* webpackChunkName: "dfpReloadInit" */ "./helpers/dfpReloadInit");
	const dfp = init(store);
	store.dispatch({
		type: "DFPHANDLER_SET",
		payload: {
			handler: dfp
		}
	});
	return dfp;
}
function lazyWithPreload(factory) {
	const Component = lazy(factory);
	Component.preload = factory;
	return Component;
}
const HomePage = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./pages/HomePage" /* webpackChunkName "HomePage" */)
);
const Section = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./pages/Section" /* webpackChunkName "Section" */)
);
const GamePage = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./pages/GamePage" /* webpackChunkName "GamePage" */)
);
const LegalPage = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./pages/LegalPage" /* webpackChunkName "LegalPage" */)
);
const ContactPage = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./pages/ContactPage" /* webpackChunkName "ContactPage" */)
);
const NotFoundPage = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./pages/NotFoundPage" /* webpackChunkName "NotFoundPage" */)
);
const PolicyPage = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./pages/PolicyPage" /* webpackChunkName "PolicyPage" */)
);
const SearchPage = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./pages/SearchPage" /* webpackChunkName "SearchPage" */)
);

const CookieLaw = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./modules/CookieLaw.jsx")
);
const MenuIzquierda = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./components/MenuIzquierda.jsx")
);
const MenuDerecha = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./components/MenuDerecha.jsx")
);
const SocialNetworks = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./components/SocialNetworks.jsx")
);
const SearchBox = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./components/search/SearchBox.jsx")
);
const SearchResults = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./components/search/SearchResults.jsx")
);
const Newsletter = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./components/Newsletter.jsx")
);
const Game = lazyWithPreload(() =>
	import(/* webpackPrefetch: true */ "./components/Game.jsx")
);

function testWebP() {
	return new Promise(res => {
		const webP = new Image();
		webP.src =
			"data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
		webP.onload = webP.onerror = function() {
			res(webP.height === 2);
		};
	});
}
function isRetinaDisplay() {
	if (window.matchMedia) {
		const mq = window.matchMedia(
			"only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 4/2), only screen and (-webkit-min-device-pixel-ratio: 2), only screen  and (min-device-pixel-ratio: 2), only screen and (min-resolution: 2dppx)"
		);
		return (mq && mq.matches) || window.devicePixelRatio > 1;
	}
}
if (window.location.pathname == "/") {
	HomePage.preload();
}

class AppContainer extends React.Component {
	constructor(props) {
		super(props);
		this.toggleMenu = this.toggleMenu.bind(this);
		this.toggleFavorite = this.toggleFavorite.bind(this);
		this.loadImagesMenuLeft = this.loadImagesMenuLeft.bind(this);
		this.loadImagesMenuRight = this.loadImagesMenuRight.bind(this);
		this.removeFav = this.removeFav.bind(this);
		this.loadGames = this.loadGames.bind(this);
		this.iddleCallback = this.iddleCallback.bind(this);
		this.moveMenu = this.moveMenu.bind(this);
		this.state = {
			positionY: 20,
			lastUrl: window.location.href
		};

		window.onload = () => {
			this.props.dispatch({
				type: "ONLOAD_EVENT",
				payload: {
					loaded: true
				}
			});
			iniciarDfp(this.props);
			if ("requestIdleCallback" in window) {
				console.log("Supports iddle callback");
				setTimeout(() => {
					window.requestIdleCallback(this.iddleCallback);
				}, 5000);
			} else {
				setTimeout(this.iddleCallback, 5000);
			}
		};
	}
	iddleCallback() {
		console.log("Running low priority tasks");

		urlPrefetch.startProcessing();
		HomePage.preload();
		Section.preload();
		GamePage.preload();
		LegalPage.preload();
		ContactPage.preload();
		NotFoundPage.preload();
		PolicyPage.preload();
		SearchPage.preload();
	}
	componentDidMount() {
		this.loadGames({
			list: this.props.MenuMostPlayed,
			showLoading: true,
			type: "section",
			payloadType: "MENU_LOAD_CATEGORIES"
		});
		this.loadGames({
			list: this.props.PlayedGames,
			showLoading: true,
			payloadType: "MENU_LOAD_PLAYED_GAMES"
		});
		this.loadGames({
			list: this.props.FavoriteGames,
			showLoading: true,
			removable: true,
			removableFunc: this.removeFav,
			payloadType: "MENU_LOAD_FAVORITE_GAMES"
		});

		// Categorias

		this.props.dispatch({
			type: "SET_FUNCTION",
			payload: {
				name: "toggleFavorite",
				func: this.toggleFavorite
			}
		});
		// Get Ads
		axios.get(this.props.ads_api).then(response => {
			this.props.dispatch({
				type: "ADS_SET_BLOCKS",
				payload: {
					data: response.data
				}
			});
		});

		testWebP().then(hasWebP => {
			this.props.dispatch({
				type: "UPDATE_WEBPSUPPORT",
				payload: {
					data: hasWebP
				}
			});
			if (!hasWebP) {
				document.getElementsByTagName("body")[0].classList.add("nowebp");
			}
		});
		this.props.dispatch({
			type: "UPDATE_ISRETINA",
			payload: {
				data: isRetinaDisplay()
			}
		});
	}
	componentDidUpdate() {
		if (this.props.section === "onlyGame") {
			setTimeout(() => {
				this.props.dispatch({
					type: "STOP_SHAKING"
				});
			}, 5000);
		}
		if (this.props.FavoriteShouldUpdate) {
			this.props.dispatch({
				type: "FAVORITE_SHOULDNT_UPDATE",
				payload: {}
			});
			this.loadGames({
				list: this.props.FavoriteGames,
				showLoading: true,
				removable: true,
				removableFunc: this.removeFav,
				payloadType: "MENU_LOAD_FAVORITE_GAMES"
			});
		}
		if (this.props.PlayedShouldUpdate) {
			this.props.dispatch({
				type: "GAMES_PLAYED_SHOULDNT_UPDATE",
				payload: {}
			});
			this.loadGames({
				list: this.props.PlayedGames,
				showLoading: true,
				payloadType: "MENU_LOAD_PLAYED_GAMES"
			});
		}
		if (
			this.props.section === "onlyGame" &&
			!this.props.relatedGames.requested
		) {
			const { gamelauncher, relatedGamesApi } = this.props;
			axios
				.get(urljoin(relatedGamesApi, gamelauncher.id.toString()), {
					params: {
						mobile: true
					}
				})
				.then(response => {
					this.props.dispatch({
						type: "GAME_SET_RELATED",
						payload: {
							data: response.data
						}
					});
				})
				.catch(ajaxError);
		}
	}
	toggleFavorite() {
		if (this.props.favorited) {
			this.props.dispatch({
				type: "REMOVE_FAVORITE",
				payload: {
					id: this.props.gamelauncher.id
				}
			});
		} else {
			this.props.dispatch({
				type: "ADD_FAVORITE",
				payload: {
					game: this.props.gamelauncher
				}
			});
		}
	}
	loadGames(settings) {
		const {
			list,
			showLoading,
			payloadType,
			removable = false,
			type = "game",
			removableFunc = () => false
		} = settings;
		// Juegos Jugados
		const gamesList = [];
		list.map(el => {
			let { id, url, name, img } = el;

			gamesList.push(
				<MenuLink
					key={id}
					id={id}
					url={url}
					name={name}
					img={img}
					type={type}
					removable={removable}
					removableFunc={removableFunc}
					isMobile={this.props.isMobile}
					showLoading={showLoading}
				/>
			);

			return el;
		});
		this.props.dispatch({
			type: payloadType,
			payload: {
				items: gamesList
			}
		});
	}
	removeFav(el) {
		const { id } = el.props;

		this.props.dispatch({
			type: "REMOVE_FAVORITE",
			payload: {
				id
			}
		});
	}

	toggleMenu(location) {
		this.props.dispatch(toggleMenuDispatcher(true, location));
	}
	loadImagesMenuLeft() {
		if (this.props.most_played_items.length > 0) {
			this.loadGames({
				list: this.props.MenuMostPlayed,
				showLoading: false,
				type: "section",
				payloadType: "MENU_LOAD_CATEGORIES"
			});
		}
	}
	loadImagesMenuRight() {
		if (typeof this.props.played_games_items !== "undefined") {
			this.loadGames({
				list: this.props.PlayedGames,
				showLoading: false,

				payloadType: "MENU_LOAD_PLAYED_GAMES"
			});
		}
		if (typeof this.props.favorites_games_items !== "undefined") {
			this.loadGames({
				list: this.props.FavoriteGames,
				showLoading: false,
				removable: true,
				removableFunc: this.removeFav,
				payloadType: "MENU_LOAD_FAVORITE_GAMES"
			});
		}
	}
	moveMenu(event) {
		if (this.props.section === "onlyGame") {
			const positionY = event.touches[0].pageY - 24;
			if (
				positionY > 2 &&
				positionY < document.documentElement.clientHeight - 60
			) {
				this.setState({
					positionY
				});
			}
		}
	}

	render() {
		const {
			translate,
			section,
			history,
			favorited,
			gamelauncher,
			shaking,
			relatedGames,
			logo
		} = this.props;

		const toShowRelated = [];
		if (section === "onlyGame") {
			let counter = 0;
			if (relatedGames.data.length > 0) {
				relatedGames.data.forEach(game => {
					if (counter < 4) {
						toShowRelated.push(<Game i={counter} key={game.id} {...game} />);
						counter += 1;
					}
				});
			}
		}

		return (
			<React.Fragment>
				<div id="outer-container">
					<header
						className="Head"
						onTouchStart={this.moveMenu}
						onTouchMove={this.moveMenu}
						style={section === "onlyGame" ? { top: this.state.positionY } : {}}
					>
						{section === "onlyGame" && shaking ? (
							<Icon
								fas
								icon={"faAngleUp"}
								className="animated swing infinite"
							/>
						) : null}
						<button
							className="Head-Menu js-Head-Menu"
							onClick={() => {
								this.toggleMenu("izquierda");
							}}
						>
							{section === "onlyGame" ? (
								<span className="s_logo_menu_desplegable" />
							) : (
								<Icon icon={"faBars"} size="lg" />
							)}

							<p>Menu</p>
						</button>
						{section === "onlyGame" && shaking ? (
							<Icon
								fas
								icon={"faAngleDown"}
								className="animated swing infinite"
							/>
						) : null}
						{section !== "onlyGame" ? (
							<React.Fragment>
								<div
									className={`Head-logo${
										this.props.sponsor !== "false"
											? " Head-logo--withsponsor"
											: ""
									}`}
								>
									<Link to="/">
										<img src={logo} alt="Logo" className="Head-logo" alt="" />
									</Link>
								</div>

								<button
									className="Head-Menu Head-Misjuegos js-Head-Menu-right"
									onClick={() => {
										this.toggleMenu("derecha");
									}}
								>
									<Icon icon={"faStar"} size="lg" />
									<p>{translate.mis_juegos}</p>
								</button>
							</React.Fragment>
						) : null}
					</header>
					<Suspense fallback={<div />}>
						<MenuIzquierda
							width="300px"
							onStateChange={this.loadImagesMenuLeft}
							className="Menu"
							pageWrapId="page-wrap"
							outerContainerId="outer-container"
							customCrossIcon={false}
							customBurgerIcon={false}
						>
							<header className="Menu-head" style={{ display: "flex" }}>
								{section === "onlyGame" ? (
									<button onClick={history.goBack}>
										<Icon icon={"faReply"} />
										<p>{translate.atras}</p>
									</button>
								) : null}
								<Link to="/">
									<Icon fas icon={"faHome"} />
									<p>{translate.home}</p>
								</Link>
								<Suspense fallback={<div />}>
									<SearchBox />
								</Suspense>
							</header>
							<Suspense fallback={<div />}>
								{this.props.search_status ? <SearchResults /> : null}
							</Suspense>
							<section className="Menu-important">
								{section === "onlyGame" ? (
									<React.Fragment>
										<ul>
											<li>
												<button
													className="favorite"
													id="add_favorite"
													onClick={this.toggleFavorite}
												>
													<Icon
														icon={favorited ? "faTimes" : "faStar"}
														className={favorited ? "" : "fa-orange"}
													/>
													{favorited
														? translate.QUITAR_FAVORITO
														: translate.AGREGAR_FAVORITO}
												</button>
											</li>
										</ul>
										<h4 className="Menu-categories-title">
											{translate.compartir_juego}
										</h4>
										<ul className="social-share mm-listview">
											<li>
												<a
													target="_blank"
													rel="noopener noreferrer"
													className="facebook"
													href={`https://m.facebook.com/dialog/feed?app_id=${
														gamelauncher.fb_app_id
													}&display=touch&link=${
														gamelauncher.full_url
													}&redirect_uri=${gamelauncher.full_url}`}
												>
													<Icon fab icon={"faFacebook"} />
													Facebook
												</a>
											</li>
											<li>
												<span
													onClick={e => twitterShare(e)}
													className="enlace twitter"
												>
													<Icon fab icon={"faTwitter"} />
													Twitter
												</span>
											</li>
											<li>
												<a
													href={`whatsapp://send?text=${gamelauncher.full_url}`}
													data-action="share/whatsapp/share"
													className="whatsapp"
												>
													<Icon fab icon={"faWhatsapp"} />
													Whatsapp
												</a>
											</li>
										</ul>
									</React.Fragment>
								) : null}
								{section !== "onlyGame" ? (
									<ul className="Menu-filters">
										<li>
											<Link to="/?sortBy=new">
												<div className="s_new" width="44" height="19" />
												{translate.GamesFilterHead_newer}
											</Link>
										</li>
										<li>
											<Link to="/?sortBy=topRated">
												<div className="s_top-rated" width="19" height="24" />
												{translate.GamesFilterHead_top_rated}
											</Link>
										</li>
									</ul>
								) : null}
							</section>
							{section !== "onlyGame" ? (
								<section className="Menu-categories">
									<h4 className="Menu-categories-title">
										{translate.categorias_top}
									</h4>
									<ul className="Menu-categories-list">
										{this.props.most_played_items}
									</ul>
								</section>
							) : (
								<section className="">
									<h4 className="Menu-categories-title">
										{translate.juegos_relacionados}
									</h4>
									<ul className="Relacionados-list mm-listview">
										{toShowRelated}
									</ul>
								</section>
							)}
						</MenuIzquierda>
					</Suspense>
					{section !== "onlyGame" ? (
						<Suspense fallback={<div />}>
							<MenuDerecha
								right
								onStateChange={this.loadImagesMenuRight}
								className="Menu-Right"
								pageWrapId="page-wrap"
								outerContainerId="outer-container"
								customCrossIcon={false}
								customBurgerIcon={false}
							>
								<h4 className="Menu-categories-title">
									{translate.juegos_favoritos}
								</h4>
								<ul className="mm-listview">
									{this.props.favorites_games_items.length === 0 ? (
										<li className="nogames">
											{translate.favoritos_description}
										</li>
									) : (
										this.props.favorites_games_items
									)}
								</ul>
								<h4 className="Menu-categories-title">
									{translate.last_played}
								</h4>
								<ul className="mm-listview">
									{this.props.PlayedGames.length === 0 ? (
										<li className="nogames">
											{translate.last_played_description}
										</li>
									) : (
										this.props.played_games_items
									)}
								</ul>
							</MenuDerecha>
						</Suspense>
					) : null}
				</div>

				<main className="Page" id="page-wrap">
					<Suspense fallback={<LoadingMessage />}>
						<Switch>
							<Route
								path={urljoin("/", this.props.section_slug, "/:section/:page?")}
								component={Section}
							/>
							<Route
								path={urljoin("/", this.props.game_splitter, "/:game")}
								component={GamePage}
							/>
							<Route
								path={urljoin("/search/:term/:page?")}
								component={SearchPage}
							/>
							<Route path="/legal" component={LegalPage} />
							<Route path="/policy" component={PolicyPage} />
							<Route path="/contact" component={ContactPage} />
							<Route exact path="/" component={HomePage} />
							<Route component={NotFoundPage} />
						</Switch>
					</Suspense>
				</main>
				{section !== "onlyGame" ? (
					<React.Fragment>
						<Suspense fallback={<div />}>
							<SocialNetworks />
						</Suspense>
						<footer className="Footer">
							<nav className="Footer-nav">
								<ul>
									<li>
										<Link to="/legal">
											{translate.aviso_legal}
											<Icon fas icon={"faAngleRight"} size="2x" />
										</Link>
									</li>
									<li>
										<Link to="/contact">
											{translate.contacto}
											<Icon fas icon={"faAngleRight"} size="2x" />
										</Link>
									</li>
								</ul>
							</nav>
						</footer>
					</React.Fragment>
				) : null}
				{localStorage.getItem("cookielaw_dismissed") !== "true" ? (
					<Suspense fallback={<div />}>
						<CookieLaw
							translate={translate}
							CookieLawUrl={this.props.CookieLawUrl}
						/>
					</Suspense>
				) : null}
			</React.Fragment>
		);
	}
}
AppContainer.propTypes = {
	burger: PropTypes.shape({
		primary: PropTypes.shape({
			isOpen: PropTypes.bool
		}),
		secondary: PropTypes.shape({
			isOpen: PropTypes.bool
		})
	}).isRequired,
	sponsor: PropTypes.string.isRequired,
	translate: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	dispatch: PropTypes.func.isRequired,
	search_status: PropTypes.bool.isRequired,
	MenuMostPlayed: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			url: PropTypes.string.isRequired,
			name: PropTypes.string.isRequired
		})
	).isRequired,
	PlayedGames: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			url: PropTypes.string.isRequired,
			name: PropTypes.string.isRequired
		})
	).isRequired,
	FavoriteGames: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			url: PropTypes.string.isRequired,
			name: PropTypes.string.isRequired
		})
	).isRequired,
	isMobile: PropTypes.bool.isRequired,
	most_played_items: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
	played_games_items: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	favorites_games_items: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	cdns: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
	ads_api: PropTypes.string.isRequired,
	section_slug: PropTypes.string.isRequired,
	game_splitter: PropTypes.string.isRequired,
	meta: PropTypes.shape({
		loading: PropTypes.bool.isRequired
	}).isRequired,
	FavoriteShouldUpdate: PropTypes.bool,
	PlayedShouldUpdate: PropTypes.bool,
	section: PropTypes.string.isRequired,
	gamelauncher: PropTypes.shape({
		id: PropTypes.string.isRequired,
		url: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		img: PropTypes.string.isRequired,
		lang_code: PropTypes.string.isRequired,
		hasTutorial: PropTypes.bool.isRequired
	}),
	favorited: PropTypes.bool.isRequired,
	history: ReactRouterPropTypes.history.isRequired, // eslint-disable-line react/no-typos
	shaking: PropTypes.bool.isRequired,
	relatedGamesApi: PropTypes.string.isRequired,
	CookieLawUrl: PropTypes.string.isRequired,
	relatedGames: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	titleApi: PropTypes.string.isRequired,
	logo: PropTypes.string.isRequired
};
AppContainer.defaultProps = {
	played_games_items: [],
	favorites_games_items: [],
	FavoriteShouldUpdate: false,
	PlayedShouldUpdate: false,
	relatedGames: {
		meta: {},
		data: [],
		requested: false
	}
};
function mapStateToProps(state) {
	return {
		burger: state.burgerMenu,
		sponsor: state.config.sponsor,
		section: state.config.section,
		translate: state.translate,
		search_status: state.search.visible,
		MenuMostPlayed: state.data.menu.most_played,
		PlayedGames: state.data.games_played.games,
		PlayedShouldUpdate: state.data.games_played.shouldUpdate,
		FavoriteGames: state.data.games_favorites.games,
		FavoriteShouldUpdate: state.data.games_favorites.shouldUpdate,
		most_played_items: state.data.menu.most_played_items,
		played_games_items: state.data.games_played.played_games_items,
		favorites_games_items: state.data.games_favorites.favorites_games_items,
		isMobile: state.config.isMobile,
		cdns: state.config.cdns,
		ads_api: state.config.routes.api.ads,
		section_slug: state.config.section_splitter,
		game_splitter: state.config.game_splitter,
		meta: state.data.juegos_destacados.meta,
		favorited:
			state.data.games_favorites.games.find(
				x =>
					typeof state.data.gamelauncher != "undefined" &&
					x.id === state.data.gamelauncher.id
			) !== undefined, // eslint-disable-line max-len
		gamelauncher: state.data.gamelauncher,
		shaking: state.config.shaking,
		relatedGames: state.data.game_relatedGames,
		relatedGamesApi: state.config.routes.api.relatedGames,
		titleApi: state.config.routes.api.title,
		CookieLawUrl: state.config.routes.cookielaw_policy,
		logo: state.config.logo
	};
}

export default withRouter(connect(mapStateToProps)(AppContainer));
